<div class="flex flex-col h-full">
  @let report = (report$ | async);
  @if (report) {
    <app-product-dashboard-header/>
  }
  <div class="flex h-full flex-1 relative">
    <app-looker-embed-sdk appFullscreenToggle (onLoaded)="onLoaded($event)" type="custom" [dashboard]="report.id.toString()" [filters]="{}" />
  </div>
</div>
